import { client } from './api';

const read = () => {
  return client('discover?status=active');
};

export { read };
